import React, { useEffect } from "react";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import { ReactComponent as SearchIcon } from "assets/icons/search-white.svg";
import { Alert, Pagination } from "@material-ui/lab";
import { Breadcrumb } from "components/breadCrumb";
import { PageTitle } from "components/pageTitle";
import { SearchButton } from "components/searchButton";
import { Wrapper } from "components/wrapper";
import CustomBackdrop from "components/backdrop";
import { UltimaAtualizacao } from "components/ultimaAtualizacao";
import { ExportButtons } from "components/exportButtons";
import { SortDirectionSelect } from "components/sortDirectionSelect";
import { useFilasEsperaState } from "./context/filas-espera-context";
import { useFilasEsperaController } from "./context/filas-espera-controller";
import { FilasEsperaTable } from "./filasEsperaTable.component";

export function FilasEsperaPage() {
  const { filas, filaPagedRequest, tipos, loading, ultimaAtualizacao, error } = useFilasEsperaState();
  const { onInit, handleOnChange, listFilas, exportFilas } = useFilasEsperaController();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    (async () => {
      await onInit();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageClick = (event: React.ChangeEvent<unknown>, value: number) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    (async () => {
      await listFilas({ ...filaPagedRequest, page: value - 1 }, true);
    })();
  };

  return (
    <>
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Filas de Espera" },
        ]}
      />
      <PageTitle>Filas de Espera</PageTitle>
      <Wrapper>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="text-field-term"
                  label="Unidade"
                  value={filaPagedRequest?.term || ''}
                  onChange={(e) => handleOnChange(e)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel shrink>Tipo de Fila</InputLabel>
                  <Select
                    name="select-tipo-id"
                    value={filaPagedRequest?.idTipoFilaEspera || ''}
                    onChange={(e) => handleOnChange(e)}
                    label="Tipo de Fila"
                    displayEmpty
                  >
                    <MenuItem value="">Todas</MenuItem>
                    {tipos?.map((t) => (
                      <MenuItem key={t.id} value={t.id}>{t.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={2}>
                <SearchButton onClick={() => (async () => {
                  await listFilas(filaPagedRequest, true);
                })()}>
                  <SearchIcon /> Consultar
                </SearchButton>
              </Grid>
              <Grid item xs={12} sm={3}>
                <SortDirectionSelect
                  value={filaPagedRequest?.orderDirection}
                  onChange={(e) => handleOnChange(e)}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <CustomBackdrop open={loading} />
            <UltimaAtualizacao data={ultimaAtualizacao} />
            <ExportButtons onExport={exportFilas} />
            {error ? (
              <Alert severity="error">{error}</Alert>
            ) : (
              <FilasEsperaTable currentItems={filas} />
            )}
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={3} justifyContent="center">
              <Pagination
                size="large"
                variant="outlined"
                shape="rounded"
                onChange={handlePageClick}
                count={filas?.pageCount}
                color="primary"
              />
            </Grid>
          </Grid>
        </Grid>
      </Wrapper>
    </>
  );
}
